<template>
  <div class="ml-2">
    <v-row align="center">
      <v-icon color="secondary lighten-1" @click="home">mdi-home-outline</v-icon> 
      <v-icon dark small>chevron_right</v-icon>
      <span> {{ currentView() }}</span>
    </v-row>
  </div>
</template>

<script>
import routes from '../../router/routes';
export default {
  name: "HomeCurrentPage",
  methods:{
    home () { this.$router.push(routes.home.path) },
    currentView () {
      const routeCurrentName = this.$route.name;
      const routesKey = Object.keys(routes);
      const routekeyOfCurrentRoute = routesKey.find((routeKey) => routes[routeKey].name === routeCurrentName)
      return routes[routekeyOfCurrentRoute].title;
    }
  }
}
</script>
<style scoped></style>
